export default __webpack_public_path__ + "static/media/misc-books2-1024w.2aef6c47.png";